import moment from "moment";

/**
 * Set the local start and end time in 12 h format based on the timestamps
 * and time zone offset.
 * @param {any[]} timeEntryModifications The list of modifications to update
 */
export function convertTo12hTime(timeEntryModifications) {
    const currentOffset = moment().utcOffset();
    for (const modification of timeEntryModifications) {
        const modificationOffset = modification.TimeZoneOffset * 60
            // Use the user's time zone current offset if the specified offset is 0
            // and the time entry was recorded in server local time.
            || (modification.IsLocalTime ? currentOffset : 0);
        modification.StartTime = moment(modification.StartDateTime).utc()
            .utcOffset(modificationOffset).format("h:mm A");
        modification.EndTime = moment(modification.EndDateTime).utc()
            .utcOffset(modificationOffset).format("h:mm A");
    }
}
